import React, { useEffect, useState } from "react";
import { ProgressBar, Step } from "react-step-progress-bar";
import "./FormComponent.css";
import "react-step-progress-bar/styles.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaCheck, FaUser, FaGlobeAmericas, FaUniversity, FaMoneyBillWave, FaPassport, FaIdCard, FaMobileAlt, FaEye, FaFileAlt, FaTrash, FaRegUser, FaCross } from "react-icons/fa";
import { MdCloudUpload, MdOutlineMan } from "react-icons/md";
import remitterImage from "../../@assets/remitter.jpg";
import { CiUser } from "react-icons/ci";
import { IoDocumentOutline, IoInformation } from "react-icons/io5";
import { ImCross } from "react-icons/im";
import individualImage from '../../@assets/individualImage.png'
import otherImage from '../../@assets/otherImage.png'


const FormComponent = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [remitterType, setRemitterType] = useState("");
  const [remitterDetails, setRemitterDetails] = useState({
    name: "",
    address: "",
    mobile: "",
    aadhaar: "",
    pan: "",
    passport: ""
  });
  const calculateSize = (size) => {
    if (size < 1024 * 1024)
      return (size / 1024).toFixed(2) + " KB"
    else
      return (size / 1024 / 1024).toFixed(2) + " MB"
  }
  const [files, setFiles] = useState({
    aadhaar: null,
    pan: null,
    passport: null
  });
  const [mobileVerified, setMobileVerified] = useState(false);
  const [docsVerified, setDocsVerified] = useState({
    aadhaar: false,
    pan: false,
    passport: false
  });
  const [beneficiaryDetails, setBeneficiaryDetails] = useState({
    name: "",
    university: "",
    course: "",
    country: "",
    amount: ""
  });
  const [showPreview, setShowPreview] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({
    aadhaar: 0,
    pan: 0,
    passport: 0
  });

  const handleNextStep = () => {
    if (currentStep < 5) {
      setCurrentStep(currentStep + 1);
    } else {
      handleSubmit();
    }
  };

  const handlePrevStep = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

  const handleSubmit = () => {
    alert(`Form submitted!\nRemitter Type: ${remitterType}\nDetails: ${JSON.stringify(remitterDetails)}\nFiles: ${Object.values(files).filter(Boolean).length}\nBeneficiary Details: ${JSON.stringify(beneficiaryDetails)}`);
  };

  const handleFileChange = (e, docType) => {
    const file = e.target.files[0];
    setFiles({
      ...files,
      [docType]: file
    });

    // Simulate file upload progress
    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      setUploadProgress(prev => ({
        ...prev,
        [docType]: progress
      }));
      if (progress >= 100) {
        clearInterval(interval);
      }
    }, 200);
  };

  const handleMobileVerification = () => {
    // Simulate mobile verification process
    setTimeout(() => setMobileVerified(true), 2000);
  };

  const handleDocVerification = (docType, verified) => {
    // Simulate document verification process
    setDocsVerified(prev => ({
      ...prev,
      [docType]: verified
    }));
  };

  useEffect(() => {
    let re = new RegExp(/^\d{12}$/);
    if (remitterDetails?.aadhaar?.length < 12)
      handleDocVerification("aadhaar", false)
    else if (re.test(remitterDetails?.aadhaar))
      handleDocVerification("aadhaar", "valid")
    else
      handleDocVerification("aadhaar", "invalid")
  }, [remitterDetails?.aadhaar])

  useEffect(() => {
    let regex = new RegExp(/^[a-zA-Z]{5}\d{4}[a-zA-Z]$/);
    console.log(remitterDetails?.pan + " " + regex.test(remitterDetails?.pan))
    if (remitterDetails?.pan?.length < 10)
      handleDocVerification("pan", false)
    else if (regex.test(remitterDetails?.pan))
      handleDocVerification("pan", "valid")
    else
      handleDocVerification("pan", "invalid")
  }, [remitterDetails?.pan])

  useEffect(() => {
    let re = new RegExp(/^[a-zA-Z0-9]{6,9}$/);
    if (remitterDetails?.passport?.length < 8)
      handleDocVerification("passport", false)
    else if (re.test(remitterDetails?.passport))
      handleDocVerification("passport", "valid")
    else
      handleDocVerification("passport", "invalid")
  }, [remitterDetails?.passport])

  const togglePreview = () => {
    setShowPreview(!showPreview);
  };
  const handleRemoveFile = (docType) => {
    setFiles({
      ...files,
      [docType]: null
    });
    setUploadProgress({
      ...uploadProgress,
      [docType]: 0
    });
  };

  const handleInputChange = (e, field) => {
    setRemitterDetails(prev => ({
      ...prev,
      [field]: e.target.value
    }));
  };

  const isAllDocsVerified = Object.values(docsVerified).every(value => value === true);

  return (
    <div className="vh-100 d-flex flex-column">
      {/* Step Progress Bar in Header */}
      <header>
        <div className="my-4">
          <div className="w-75 mx-auto">
            <ProgressBar
              percent={((currentStep - 1) / 4) * 100}
              // filledBackground="linear-gradient(to right, #198754, #19875440)"
              filledBackground="linear-gradient(to right, #0275d8, #4A6F28)"
              height={8}
            >
              {[FaRegUser, IoDocumentOutline, IoInformation, FaCheck, MdOutlineMan].map((Item, key) => (
                <Step key={key + 1} transition="">
                  {({ accomplished }) => (
                    <div className={`indexedStep ${key + 1 === currentStep ? "" : accomplished ? "bg-primary" : ""}`}>
                      {key + 1 < currentStep ? (
                        <FaCheck className="text-white " size={14} />
                      ) : (
                        <div className={`circle ${key + 1 === currentStep ? "border-primary border-2 text-primary" : "gray-circle text-dark"}`}>
                          <Item className=" " size={14} />
                        </div>
                      )}
                    </div>
                  )}
                </Step>
              ))}
            </ProgressBar>
          </div>
        </div>
      </header>

      {/* Form Content */}
      <div className={`d-flex flex-column align-items-center bg-light`} >
        <div className="form-container w-100 px-4 px-md-5 py-4 bg-white shadow rounded-lg mt-2" style={{ maxWidth: '1200px' }}>
          <h2 className="form-title text-primary mb-0">International Education Remittance</h2>
          <p className="form-subtitle text-muted mt-0 small">Secure your future with hassle-free overseas education payments</p>

          {currentStep === 1 && (
            <div className="row justify-content-center mt-4">

              <div className="text-center">
                <h2>Choose Remitter Type</h2>
                <div>
                </div>
                <img src={individualImage} alt="individual" width={150} />
                <img src={otherImage} alt="group" width={100} />

              </div>
              <div className="col-md-6">
                <img src={remitterImage} alt="Remittance" className="img-fluid rounded" style={{ width: '100%', height: 'auto' }} />
              </div>
              <div className="col-md-4 d-flex align-items-end">
                <div className="form-group mb-4 w-100">
                  <label htmlFor="remitterType" className="form-label fw-bold">
                    <FaUser className="me-2" />
                    Choose Remitter Type
                  </label>
                  <select
                    id="remitterType"
                    className="form-select form-select-md custom-select modern-select w-100"
                    value={remitterType}
                    onChange={(e) => setRemitterType(e.target.value)}
                  >
                    <option value="" disabled>Select type</option>
                    <option value="Self">Self</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>
            </div>
          )}
          {currentStep === 2 && (
            <div className="row">
              {['aadhaar', 'pan', 'passport'].map((docType) => (
                <div key={docType} className="col-md-4 mb-3">
                  <label className="form-label fw-bold">
                    <MdCloudUpload className="me-2" />
                    Upload {docType.charAt(0).toUpperCase() + docType.slice(1)}
                  </label>
                  <div className="file-upload-container">
                    <input
                      id={docType}
                      type="file"
                      onChange={(e) => handleFileChange(e, docType)}
                      className="file-input"
                      accept=".pdf,.jpg,.jpeg,.png"
                    />
                    <div className="file-upload-area">
                      {uploadProgress[docType] > 0 && uploadProgress[docType] < 100 ? (
                        <div className="upload-progress">
                          <div className="progress-circle">
                            <svg viewBox="0 0 36 36" className="circular-chart">
                              <path
                                className="circle-bg"
                                d="M18 2.0845
                                  a 15.9155 15.9155 0 0 1 0 31.831
                                  a 15.9155 15.9155 0 0 1 0 -31.831"
                              />
                              <path
                                className="circle"
                                strokeDasharray={`${uploadProgress[docType]}, 100`}
                                d="M18 2.0845
                                  a 15.9155 15.9155 0 0 1 0 31.831
                                  a 15.9155 15.9155 0 0 1 0 -31.831"
                              />
                            </svg>
                            <span className="progress-percentage">{uploadProgress[docType]}%</span>
                          </div>
                        </div>
                      ) : files[docType] ? (
                        <div className="file-uploaded">
                          <div className="file-icon">
                            <FaFileAlt size={48} color="#4CAF50" />
                          </div>
                          <div className="file-details">
                            <span className="file-name">{files[docType].name}</span>
                            <br />
                            <span className="file-size">{calculateSize(files[docType].size)}</span>
                          </div>
                          <button className="remove-file" type="button" onClick={(e) => { e.stopPropagation(); handleRemoveFile(docType) }}>
                            <FaTrash size={18} />
                          </button>
                        </div>
                      ) : (
                        <label htmlFor={docType} className="file-upload-label">
                          <div className="upload-icon">
                            <MdCloudUpload size={48} />
                          </div>
                          <div className="upload-text">
                            <span className="upload-title">Select a {docType.charAt(0).toUpperCase() + docType.slice(1)} file to upload</span>
                            <br />
                            <span className="upload-subtitle">or drag and drop it here</span>
                          </div>
                        </label>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
          {currentStep === 3 && (
            <div className="row">
              <div className="col-md-4 mb-3">
                <label htmlFor="aadhaar" className="form-label fw-bold">
                  Aadhaar Number
                </label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    id="aadhaar"
                    value={remitterDetails.aadhaar}
                    onChange={(e) => handleInputChange(e, 'aadhaar')}
                    placeholder="Enter Aadhaar number"
                  />
                  {docsVerified.aadhaar === "valid" && (
                    <span className="input-group-text bg-success text-white">
                      <FaCheck />
                    </span>
                  )}
                  {docsVerified.aadhaar === "invalid" && (
                    <span className="input-group-text bg-danger text-white">
                      <ImCross />
                    </span>
                  )}
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <label htmlFor="pan" className="form-label fw-bold">
                  PAN Number
                </label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    id="pan"
                    value={remitterDetails.pan}
                    onChange={(e) => handleInputChange(e, 'pan')}
                    placeholder="Enter PAN number"
                  />
                  {docsVerified.pan === "valid" && (
                    <span className="input-group-text bg-success text-white">
                      <FaCheck />
                    </span>
                  )}
                  {docsVerified.pan === "invalid" && (
                    <span className="input-group-text bg-danger text-white">
                      <ImCross />
                    </span>
                  )}
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <label htmlFor="passport" className="form-label fw-bold">
                  Passport Number
                </label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    id="passport"
                    value={remitterDetails.passport}
                    onChange={(e) => handleInputChange(e, 'passport')}
                    placeholder="Enter Passport number"
                  />
                  {docsVerified.passport === "valid" && (
                    <span className="input-group-text bg-success text-white">
                      <FaCheck />
                    </span>
                  )}
                  {docsVerified.passport === "invalid" && (
                    <span className="input-group-text bg-danger text-white">
                      <ImCross />
                    </span>
                  )}
                </div>
              </div>
            </div>
          )}
          {currentStep === 4 && (
            <div className="row">
              <div className="col-md-6 mb-3">
                <label htmlFor="mobileVerification" className="form-label fw-bold">
                  <FaMobileAlt className="me-2" />
                  Verify Mobile Number
                </label>
                <button
                  className="btn btn-primary btn-lg w-100 modern-button"
                  onClick={handleMobileVerification}
                  disabled={mobileVerified}
                >
                  {mobileVerified ? "Verified" : "Verify Now"}
                </button>
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label fw-bold">
                  <FaEye className="me-2" />
                  Preview Documents
                </label>
                <button
                  className="btn btn-secondary btn-lg w-100 modern-button"
                  onClick={togglePreview}
                >
                  {showPreview ? "Hide Preview" : "Show Preview"}
                </button>
              </div>
              {showPreview && (
                <div className="col-12 mt-3">
                  <h4>Uploaded Documents:</h4>
                  <div className="row">
                    {Object.entries(files).map(([key, value]) => (
                      <div key={key} className="col-md-4 mb-3">
                        <div className="card">
                          <div className="card-body">
                            <h5 className="card-title">{key.charAt(0).toUpperCase() + key.slice(1)}</h5>
                            {value ? (
                              <div className="document-preview">
                                {value.type.startsWith('image/') ? (
                                  <img src={URL.createObjectURL(value)} alt={key} className="img-fluid" />
                                ) : (
                                  <p>{value.name}</p>
                                )}
                              </div>
                            ) : (
                              <p>Not uploaded</p>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
          {currentStep === 6 && (
            <div className="row">
              <h3 className="mb-4">Beneficiary Details</h3>
              <div className="col-md-6 mb-3">
                <label htmlFor="beneficiaryName" className="form-label fw-bold">
                  <FaUser className="me-2" />
                  Beneficiary Name
                </label>
                <input
                  id="beneficiaryName"
                  type="text"
                  className="form-control form-control-lg modern-input"
                  value={beneficiaryDetails.name}
                  onChange={(e) => setBeneficiaryDetails({ ...beneficiaryDetails, name: e.target.value })}
                  placeholder="Enter beneficiary name"
                />
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="university" className="form-label fw-bold">
                  <FaUniversity className="me-2" />
                  University
                </label>
                <input
                  id="university"
                  type="text"
                  className="form-control form-control-lg modern-input"
                  value={beneficiaryDetails.university}
                  onChange={(e) => setBeneficiaryDetails({ ...beneficiaryDetails, university: e.target.value })}
                  placeholder="Enter university name"
                />
              </div>
              <div className="col-md-4 mb-3">
                <label htmlFor="course" className="form-label fw-bold">
                  <FaGlobeAmericas className="me-2" />
                  Course
                </label>
                <input
                  id="course"
                  type="text"
                  className="form-control form-control-lg modern-input"
                  value={beneficiaryDetails.course}
                  onChange={(e) => setBeneficiaryDetails({ ...beneficiaryDetails, course: e.target.value })}
                  placeholder="Enter course name"
                />
              </div>
              <div className="col-md-4 mb-3">
                <label htmlFor="country" className="form-label fw-bold">
                  <FaGlobeAmericas className="me-2" />
                  Country
                </label>
                <input
                  id="country"
                  type="text"
                  className="form-control form-control-lg modern-input"
                  value={beneficiaryDetails.country}
                  onChange={(e) => setBeneficiaryDetails({ ...beneficiaryDetails, country: e.target.value })}
                  placeholder="Enter country name"
                />
              </div>
              <div className="col-md-4 mb-3">
                <label htmlFor="amount" className="form-label fw-bold">
                  <FaMoneyBillWave className="me-2" />
                  Remittance Amount
                </label>
                <div className="input-group">
                  <span className="input-group-text">$</span>
                  <input
                    type="number"
                    className="form-control form-control-lg"
                    id="amount"
                    value={beneficiaryDetails.amount}
                    onChange={(e) => setBeneficiaryDetails({ ...beneficiaryDetails, amount: e.target.value })}
                    placeholder="Enter amount to transfer"
                  />
                  <span className="input-group-text">USD</span>
                </div>
              </div>
            </div>
          )}

          {/* Navigation Buttons */}
          <div className="button-contain d-flex mt-5">
            {currentStep > 1 && (
              <button className="btn btn-outline-secondary btn-lg prev-button modern-button" onClick={handlePrevStep}>
                ← Previous
              </button>
            )}
            <button
              className={`btn btn-${currentStep !== 5 ? "outline-" : ""}primary ms-auto btn-lg next-button modern-button`}
              onClick={handleNextStep}
              disabled={currentStep === 1 && !remitterType}
            >
              {currentStep === 5 ? "Submit" : "Next →"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormComponent;
